import React from "react";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { UiButtonProps } from "../../models/components/button.model";

const UiButton = (props: UiButtonProps) => {
	const { t } = useTranslation("common");

	return (
		<Button
			id={props?.id}
			type={props?.type}
			label={props?.label ? t(`${props?.label}`) : undefined}
			icon={props?.icon}
			// Default to "left" so PrimeReact renders `p-button-icon-left` (not
			// `p-button-icon-undefined`). React 19 ignores the component defaultProps
			// that used to supply this, which is why the theme's icon margin — and
			// thus the icon↔label spacing — stopped applying.
			iconPos={props?.iconPos ?? "left"}
			tooltip={props?.tooltip ? t(`${props?.tooltip}`) : undefined}
			tooltipOptions={props?.tooltipOptions}
			loading={props?.loading}
			loadingIcon="pi pi-spin pi-spinner"
			className={props?.className}
			disabled={props?.disabled}
			onClick={props?.onClick}
			style={props?.style}
			data-testid={props.testId}
		/>
	);
};

export default UiButton;
